import { overlayLayers } from 'constants/imagery';
import {
  getLatestSoilDataForFieldId
} from 'imagery/soil/selectors';

export const getSoilLegendForFieldId = (state, fieldId) => {
  const soilData = getLatestSoilDataForFieldId(state, fieldId);
  const bins = Object.values(soilData).map((soilZone) => {
    const { 'parsed-muname': muname, 'drainage-class': drainage} = soilZone.geoJson.properties;
    return `${muname} - ${drainage}`;
  });
  return {
    bins,
    labelKey: `label-text__overlay-legend--${overlayLayers.SOIL}`
  };
};
